module.exports = __webpack_public_path__ + "fonts/futura-book-regular.2c2efcc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/scandinavian-forest/fonts/futura-book-regular.woff
// module id = 402
// module chunks = 0